export const fakeScheduleData = [
    {
        "pOfL": "Live Chat",
        banner: "https://superstarcommunicator.com/wp-content/uploads/2013/12/business-people-on-a-table.jpg",
        total: 15
    },
    {
        "pOfL": "Learning Session",
        banner: "https://superstarcommunicator.com/wp-content/uploads/2013/12/business-people-on-a-table.jpg",
        total: 15
    },
    {
        "pOfL": "Meetup Events",
        banner: "https://superstarcommunicator.com/wp-content/uploads/2013/12/business-people-on-a-table.jpg",
        total: 14
    },
    {
        "pOfL": "Audition",
        banner: "https://superstarcommunicator.com/wp-content/uploads/2013/12/business-people-on-a-table.jpg",
        total: 13
    },
    {
        "pOfL": "Greetings",
        banner: "https://superstarcommunicator.com/wp-content/uploads/2013/12/business-people-on-a-table.jpg",
        total: 12
    },
]